import { render, staticRenderFns } from "./EditableColumn.vue?vue&type=template&id=6b1c42a3&"
import script from "./EditableColumn.vue?vue&type=script&lang=js&"
export * from "./EditableColumn.vue?vue&type=script&lang=js&"
import style0 from "./EditableColumn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports